var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "map-wrapper overflow-hidden",
      attrs: { id: _vm.id + "-fullscreen" },
    },
    [
      _c("map-loading", { attrs: { loading: _vm.loadingMap } }),
      _vm._v(" "),
      _c("div", { staticClass: "ol-popup", attrs: { id: "map-popup" } }),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.mapClass,
          attrs: { id: _vm.id },
          on: { click: _vm.onClickMap },
        },
        [
          _c("map-feedbackoptions-control", {
            attrs: { moduleCode: _vm.moduleCode, showBtnMap: false },
          }),
          _vm._v(" "),
          _vm.activeExpandCollapse
            ? _c("map-expandcollapse-control", {
                attrs: {
                  posBtnMap: _vm.mapButtons.expandcollapse.position,
                  idxBtnMap: _vm.mapButtons.expandcollapse.order,
                  showLabelBtnMap: _vm.mapButtons.expandcollapse.showLabel,
                  collapsed: _vm.initialCollapsedExpandCollapse,
                  showButtonOnActionMap: false,
                  moduleCode: _vm.moduleCode,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.enableZoom
            ? _c("map-zoom-control", {
                attrs: {
                  posBtnMap: _vm.mapButtons.zoom.position,
                  idxBtnMap: _vm.mapButtons.zoom.order,
                  asGroup: _vm.mapButtons.zoom.group,
                  moduleCode: _vm.moduleCode,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.enableAttribution
            ? _c("map-attribution-control", {
                attrs: {
                  posBtnMap: _vm.mapButtons.attribution.position,
                  subPosBtnMap: _vm.mapButtons.attribution.subposition,
                  idxBtnMap: _vm.mapButtons.attribution.order,
                  moduleCode: _vm.moduleCode,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.enableScaleLine
            ? _c("map-scaleline-control", {
                attrs: {
                  posBtnMap: _vm.mapButtons.scaleline.position,
                  subPosBtnMap: _vm.mapButtons.scaleline.subposition,
                  idxBtnMap: _vm.mapButtons.scaleline.order,
                  moduleCode: _vm.moduleCode,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.enableScaleBox
            ? _c("map-scalebox-control", {
                attrs: {
                  posBtnMap: _vm.mapButtons.scalebox.position,
                  subPosBtnMap: _vm.mapButtons.scalebox.subposition,
                  idxBtnMap: _vm.mapButtons.scalebox.order,
                  moduleCode: _vm.moduleCode,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.enableMousePosition
            ? _c("map-mouseposition-control", {
                attrs: {
                  posBtnMap: _vm.mapButtons.mouseposition.position,
                  subPosBtnMap: _vm.mapButtons.mouseposition.subposition,
                  idxBtnMap: _vm.mapButtons.mouseposition.order,
                  moduleCode: _vm.moduleCode,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.enableGeoLocation
            ? _c("map-geolocation-control", {
                attrs: {
                  posBtnMap: _vm.mapButtons.geolocation.position,
                  idxBtnMap: _vm.mapButtons.geolocation.order,
                  moduleCode: _vm.moduleCode,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.enableFullScreen
            ? _c("map-fullscreen-control", {
                attrs: {
                  posBtnMap: _vm.mapButtons.fullscreen.position,
                  idxBtnMap: _vm.mapButtons.fullscreen.order,
                  moduleCode: _vm.moduleCode,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.enableStreetView
            ? _c("map-streeview-control", {
                attrs: {
                  posBtnMap: _vm.mapButtons.streetview.position,
                  idxBtnMap: _vm.mapButtons.streetview.order,
                  moduleCode: _vm.moduleCode,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.enableMeasure
            ? _c("map-measure-control", {
                attrs: {
                  posBtnMap: _vm.mapButtons.measure.position,
                  idxBtnMap: _vm.mapButtons.measure.order,
                  moduleCode: _vm.moduleCode,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.enableLayerSwitcher
            ? _c("map-layerswitcher-control", {
                attrs: {
                  posBtnMap: _vm.mapButtons.layerswitcher.position,
                  idxBtnMap: _vm.mapButtons.layerswitcher.order,
                  moduleCode: _vm.moduleCode,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._t("default"),
          _vm._v(" "),
          _vm.enableLinks
            ? _c("map-links-control", {
                attrs: {
                  posBtnMap: _vm.mapButtons.links.position,
                  idxBtnMap: _vm.mapButtons.links.order,
                  showLabelBtnMap: _vm.mapButtons.links.showLabel,
                  showButtonOnActionMap: false,
                  moduleCode: _vm.moduleCode,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.enableBackoffice
            ? _c("map-backoffice-control", {
                attrs: {
                  posBtnMap: _vm.mapButtons.backoffice.position,
                  idxBtnMap: _vm.mapButtons.backoffice.order,
                  showLabelBtnMap: _vm.mapButtons.backoffice.showLabel,
                  collapsible: _vm.mapButtons.backoffice.collapsible,
                  collapsed: _vm.initialCollapsedExpandCollapse,
                  showButtonOnActionMap: false,
                  moduleCode: _vm.moduleCode,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.enableIdentify
            ? _c("map-identify-control", {
                attrs: {
                  "data-panel": "identify",
                  moduleCode: _vm.moduleCode,
                  showButtonOnActionMap: false,
                  showBtnMap: false,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.enableCatalog
            ? _c("map-catalog-control", {
                attrs: {
                  "data-panel": "catalog",
                  moduleCode: _vm.moduleCode,
                  showButtonOnActionMap: false,
                  showBtnMap: false,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.enableAnnotations
            ? _c("map-annotations-control", {
                attrs: {
                  "data-panel": "annotations",
                  moduleCode: _vm.moduleCode,
                  posBtnMap: _vm.mapButtons.annotations.position,
                  idxBtnMap: _vm.mapButtons.annotations.order,
                  showLabelBtnMap: _vm.mapButtons.annotations.showLabel,
                  collapsible: _vm.mapButtons.annotations.collapsible,
                  collapsed: _vm.initialCollapsedExpandCollapse,
                  showButtonOnActionMap: false,
                },
              })
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }